import {ActionTree, GetterTree, Module, MutationTree} from 'vuex';
import {RepositoryFactory} from '@/api/RepositoryFactory';
import {ActuatorTypeState, RootState} from '@/store/storeStateInterface';
import {ActuatorType} from "@/models/actuatorType";
import ActuatorTypeRepository from "@/api/ActuatorTypeRepository";

const store: ActuatorTypeState = {
    actuatorTypes: [],
    actuatorType: {} as ActuatorType
};
const actuatorTypeRepository: ActuatorTypeRepository = RepositoryFactory.get('actuatorType');

const actions: ActionTree<ActuatorTypeState, RootState> = {
    loadActuatorType: async ({ commit }, payload: { id: string }): Promise<ActuatorType> => {
        const response = await actuatorTypeRepository.getActuatorType(payload.id);
        commit('setActuatorType', new ActuatorType(response.data));
        return new ActuatorType(response.data);
    },
    loadAllActuatorTypes: async ({ commit }): Promise<ActuatorType[]> => {
        const response = await actuatorTypeRepository.getAllActuatorTypes();
        const actuatorTypes = response.data.map((data: any) => new ActuatorType(data));
        commit('setActuatorTypes', actuatorTypes);
        return actuatorTypes;
    },
    updateActuatorType: async ({ commit }, payload: { actuatorType: ActuatorType }): Promise<ActuatorType> => {
        const response = await actuatorTypeRepository.updateActuatorType(payload.actuatorType);
        return new ActuatorType(response.data);
    },
    createActuatorType: async ({ commit }, payload: { actuatorType: ActuatorType }): Promise<ActuatorType> => {
        const response = await actuatorTypeRepository.createActuatorType(payload.actuatorType);
        return new ActuatorType(response.data);
    },
    // Löscht einen Antriebstyp anhand seiner ID
    deleteActuatorType: async ({ commit }, payload: { id: string }): Promise<void> => {
        await actuatorTypeRepository.deleteActuatorType(payload.id);
    },
    /*
    deleteCustomer: async ({ commit }, payload: { id: string }): Promise<Customer> => {
        const response = await customerRepository.deleteCustomer(payload.id);
        return response.data;
    }
    
     */
};

const mutations: MutationTree<ActuatorTypeState> = {
    setActuatorTypes: (state: ActuatorTypeState, actuatorTypes: any[]) => {
        state.actuatorTypes = actuatorTypes;
    }
};

const getters: GetterTree<ActuatorTypeState, RootState> = {
    actuatorTypes: (state: ActuatorTypeState) => state.actuatorTypes,
};

const actuatorTypeStore: Module<ActuatorTypeState, RootState> = {
    state: store,
    actions,
    mutations,
    getters
};

export default actuatorTypeStore;
